import { secondsToTimeString } from '@/helpers/dateHelper';
import { WorkingShift } from '@/types/daily.types';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { InfoCell } from '../../../components/shared/InfoCell';
import { useRosterEmployeeSummary } from '../providers/WorkingRosterService';

interface MonthlyTotalColumnsProps {
  shift: WorkingShift;
}

export const MonthlyTotalColumns: FC<MonthlyTotalColumnsProps> = ({ shift }) => {
  const summary = useRosterEmployeeSummary(shift.assignedEmployeeId);

  const minTime = summary?.homeEmployee ? summary?.settings.minMonthlyHours : undefined;
  const maxTime = summary?.homeEmployee ? summary?.settings.maxMonthlyHours : undefined;
  const total = summary?.homeEmployee ? summary?.compliance.actualTime : undefined;

  let totalColorClass = '';
  if (total) {
    if (minTime !== undefined && total < minTime) {
      totalColorClass = 'text-primary';
    } else if (maxTime !== undefined && total > maxTime) {
      totalColorClass = 'text-secondary';
    }
  }

  return (
    <InfoCell className={twMerge('flex-1', totalColorClass, total !== undefined ? '' : 'bg-gray-100')}>
      <p>{total ? secondsToTimeString(total) : '--:--'}</p>
    </InfoCell>
  );
};
